import { ChakraV3, dataAttr } from '@piccolohealth/ui';
import type { Editor } from '@tiptap/react';
import React from 'react';
import { FaBold, FaItalic, FaStrikethrough, FaUnderline } from 'react-icons/fa';

interface Props {
  editor: Editor;
}

export const MarkSelect = (props: Props) => {
  const { editor } = props;

  const items = [
    {
      icon: FaBold,
      title: 'Bold',
      action: () => editor.chain().focus().toggleBold().run(),
      isActive: () => editor.isActive('bold'),
    },
    {
      icon: FaItalic,
      title: 'Italic',
      action: () => editor.chain().focus().toggleItalic().run(),
      isActive: () => editor.isActive('italic'),
    },
    {
      icon: FaStrikethrough,
      title: 'Strikethrough',
      action: () => editor.chain().focus().toggleStrike().run(),
      isActive: () => editor.isActive('strike'),
    },
    {
      icon: FaUnderline,
      title: 'Underline',
      action: () => editor.chain().focus().toggleUnderline().run(),
      isActive: () => editor.isActive('underline'),
    },
  ];

  return (
    <ChakraV3.HStack gap={0} rounded='lg' overflow='hidden'>
      {items.map((item) => (
        <ChakraV3.IconButton
          key={item.title}
          aria-label={item.title}
          variant='ghost'
          size='xs'
          rounded='none'
          onClick={item.action}
          {...{ 'data-active': dataAttr(item.isActive()) }}
        >
          <item.icon />
        </ChakraV3.IconButton>
      ))}
    </ChakraV3.HStack>
  );
};
